module.exports = __webpack_public_path__ + "static/media/thematic2.edd5761e.jpg";